export enum TelegramChatSettingsTabsEnum {
  ASSIGNED = 'Assigned',
  ALL = 'All',
}

export enum TelegramChatSettingsTableTypesEnum {
  CARD_ASSIGNED = 'CARD_ASSIGNED',
  ALL = 'ALL',
}
